export const levelOrder = {
	trace: 10,
	debug: 20,
	info: 30,
	warn: 40,
	error: 50,
	fatal: 60,
} as const;

export type SentryLogLevel = keyof typeof levelOrder;

export function buildBeforeSendLog(
	minSentryLogLevel: SentryLogLevel
): (log: any) => any {
	const resolvedMinLevel = levelOrder[minSentryLogLevel] ?? levelOrder.error;

	return function beforeSendLog(log: any) {
		if (log.attributes?.forceSentry === true) {
			return log;
		}

		const logLevelKey = String(log.level) as SentryLogLevel;
		const logLevelValue = levelOrder[logLevelKey];

		// Drop logs with unknown or unsupported levels instead of letting them through.
		if (typeof logLevelValue !== 'number') {
			return null;
		}

		if (logLevelValue < resolvedMinLevel) {
			return null;
		}
		return log;
	};
}
